<template>
	<main class="proTips">
		<article class="container">
			<section v-if="bannerMultiData?.knowhow" class="section_banner banner">
				<SubSwiperSlide v-if="!isBannerMultiLoading" :data="bannerMultiData?.knowhow ?? []" />
			</section>
			<!-- 노하우 탭 -->
			<TabBar :items="['All', ...(knowhowTabList?.know_tabs ?? [])]" fixed-width @click-tab="onSelectKnowhowTab" />
			<!-- <TabBar
				:items="['ALL', 'BEST', ...(knowhowTabList?.know_tabs?.slice(0, 3) ?? [])]"
				fixed-width
				@click-tab="onSelectKnowhowTab"
			/> -->
			<section class="section_content c_inner">
				<div class="content_search">
					<InputSearch
						v-model="searchValue"
						is-left
						:placeholder="PLACEHOLDER_SEARCH_TITLE_OR_AUTHOR"
						@input="debounceRefetchKnowhow"
						@on-delete="debounceRefetchKnowhow"
					/>
				</div>
				<div class="content_list">
					<div class="list_filter select_box">
						<select
							v-model="sortData"
							class="c_select"
							@change="router.push({ query: { sort: sortData, tab: route.query.tab } })"
						>
							<option value="LATEST">최신순</option>
							<option value="HITS">조회수 순</option>
							<option value="LIKES">좋아요 순</option>
						</select>
					</div>
					<ul class="list_listItem">
						<li v-for="(item, index) in knowhowData?.knowhow" :key="index" @click="onClickListItem(item.knowhow_pk)">
							<div class="img_box">
								<img v-if="item.file_path" :src="item.file_path" alt="리스트 대표 이미지" loading="lazy" />
								<img v-else src="@/assets/img/proTips/default.svg" alt="기본 대표 이미지" loading="lazy" />
							</div>
							<div class="listItem_info">
								<div class="info_header">
									<div v-if="item.knowhow_fixed_yn === 'Y'" class="c_tag color-red">공지</div>
									<div v-if="item.knowhow_best_yn === 'Y'" class="c_tag color-blue">BEST</div>
									<h3>{{ item.knowhow_title }}</h3>
								</div>
								<div class="listItem_meta">
									<div class="meta_subInfo">
										<span>{{ item.member_nickname }}</span>
										<span>조회수{{ Number(item.knowhow_hitcount) }}</span>
										<span>{{ item.knowhow_enrollment_date.split(' ')[0] }}</span>
									</div>
									<div class="meta_icon">
										<div>
											<HeartIcon /><span>{{ Number(item.knowhow_likecount) }}</span>
										</div>
										<div>
											<CommentIcon /><span>{{ item.comment_count }}</span>
										</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
					<div class="button_box">
						<button class="c_button mid" @click="onClickPostCreation">게시글 작성</button>
					</div>
					<Pagination
						v-if="knowhowData?.knowhow_count"
						:current-page="Number(route.query.page ?? 1)"
						:total-count="knowhowData?.knowhow_count ? Math.ceil(Number(knowhowData?.knowhow_count) / 10) : 0"
						@set-page="(page: number) => router.replace({ query: { ...route.query, page: page } })"
					/>
				</div>
			</section>
		</article>
	</main>
	<Modal v-if="route.query.modal === 'open'" modal-name="PostCreation" title="게시글작성">
		<PostCreation @save-knowhow="updateSaveKnowhow" />
	</Modal>
	<HomePopup :exposure-location="'knowhow'" />
</template>

<script setup lang="ts">
// lib
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { debounce } from 'lodash';

import { useGetCheckAuthApi } from '@/api/auth';
// api
import { useGetBannerMultiApi } from '@/api/banner';
import { useGetKnowhowApi, useGetKnowhowAuthApi, useGetKnowhowTabListApi } from '@/api/proTips';
import CommentIcon from '@/assets/img/proTips/comment.svg?component';
// asset
import HeartIcon from '@/assets/img/proTips/heart.svg?component';
// component
import InputSearch from '@/components/atom/input/InputSearch.vue';
import TabBar from '@/components/atom/tabBar/TabBar.vue';
import Pagination from '@/components/layout/common/Pagination.vue';
import Modal from '@/components/modal/Modal.vue';
import HomePopup from '@/components/popup/HomePopup.vue';
import PostCreation from '@/components/proTips/PostCreation.vue';
import SubSwiperSlide from '@/components/swiper/SubSwiperSlide.vue';
// constant
import { NO_POSTING_PERMISSION, PLACEHOLDER_SEARCH_TITLE_OR_AUTHOR } from '@/constants/title';
import { useHeaderStore } from '@/stores/header';
import { useLoginPopupStore } from '@/stores/LoginPopup';
// store
import { useModalStore } from '@/stores/modal';

// -----variable-----
const route = useRoute();
const router = useRouter();
const loginPopupStore = useLoginPopupStore();
const modalStore = useModalStore();
const headerStore = useHeaderStore();

const searchValue = ref('');
const searchData = ref('');
const sortData = ref<string>('LATEST');
// -----api-----
const { data: bannerMultiData, isLoading: isBannerMultiLoading } = useGetBannerMultiApi({
	type: 'knowhow',
});
const { data: knowhowData, refetch: refetchKnowhow } = useGetKnowhowApi(
	computed(() => {
		return {
			category: route.query.tab,
			search: searchData.value,
			page: Number(route.query.page ?? 1),
			row: 10,
			sort: sortData.value,
		};
	})
);
const { refetch: refetchKnowhowAuth } = useGetKnowhowAuthApi();
const { refetch: checkAuthRefetch } = useGetCheckAuthApi(
	computed(() => {
		return {
			num: 'ONE',
			student: false,
		};
	})
);
const { data: knowhowTabList } = useGetKnowhowTabListApi();
// -----function-----
//노하우 탭 클릭 시
const onSelectKnowhowTab = async (tabName: string) => {
	let tab = tabName;
	if (tabName === 'All') {
		tab = '';
	}
	router.replace({ query: { tab: tab } });
};

const checkAuthority = async () => {
	const res = await checkAuthRefetch();
	if (!res.data?.success) {
		modalStore.openModal('GuideModal');
		return false;
	}

	return true;
};

const onClickListItem = async (pk: number) => {
	router.push(`/protips/post-detail/${pk}`);
};

const onClickPostCreation = async () => {
	const authRes = await refetchKnowhowAuth();
	if (!authRes.data?.success) {
		loginPopupStore.openPopup({
			icon: 'alert',
			content: NO_POSTING_PERMISSION,
		});
		return;
	}

	if (!(await checkAuthority())) return;

	router.replace({ query: { modal: 'open' } });
};
const updateSaveKnowhow = async () => {
	await refetchKnowhow();
};
const debounceRefetchKnowhow = debounce(() => {
	router.push({
		query: {
			keyword: searchValue.value,
			tab: route.query.tab,
		},
	});
	searchData.value = searchValue.value;
}, 500);
watch(
	() => route.query,
	async () => {
		await refetchKnowhow();
	}
);
watch(
	() => route.query.modal,
	() => {
		if (route.query.modal === 'open') {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}
	}
);

onMounted(async () => {
	if (route.query.keyword) {
		searchValue.value = String(route.query.keyword);
		searchData.value = searchValue.value;
	}
	await refetchKnowhow();
});

onBeforeMount(async () => {
	const res = await checkAuthRefetch();
	if (!res.data?.success) {
		router.replace(`/subscribe/${headerStore.getCountry?.toLowerCase()}/not`);
	}
});
</script>

<style lang="scss" scoped>
.knowhow-tab {
	&__container {
		border-bottom: 0.1rem solid var(--color-base-mid-dark);
		& .swiper-slide {
			width: auto !important;
		}
		& button {
			width: 100%;
			min-width: 17rem;
			height: 5.3rem;
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-semi-bold);
			line-height: 2.1rem;
			text-align: center;
			color: var(--color-base-light);
			&.on {
				color: var(--color-primary);
				border-bottom: 1.4px solid var(--color-primary);
			}
		}
	}
}

.proTips {
	padding-top: var(--header-height);
	padding-bottom: 8.8rem;
	@media screen and (max-width: 1280px) {
		padding-bottom: 8rem;
	}
}
.proTips .container {
	display: flex;
	flex-direction: column;
	gap: 4rem;
	width: 100%;
	max-width: 68rem;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	padding-top: 8.8rem;
	margin: 0 auto;
	@media screen and (max-width: 1280px) {
		padding-top: 4rem;
	}
	.banner {
		:deep(.swiper) {
			.swiper-slide > img {
				border-radius: var(--border-radius-small);
				height: 18rem;
				@media screen and (max-width: 1280px) {
					height: 14rem;
				}
			}
			.swiper-pagination {
				position: unset;
				padding-top: 1rem;
			}
		}
	}
}
.proTips .container .c_inner {
	display: flex;
	flex-direction: column;
	gap: 4rem;
	padding: 0;
	@media screen and (max-width: 1280px) {
		padding: 0 2rem;
	}
}
.proTips .container .c_inner .select_box {
	text-align: end;
	padding-bottom: 1rem;
	border-bottom: 1px solid var(--color-base-mid-dark);
}
.proTips .container .c_inner .list_listItem {
	display: flex;
	flex-direction: column;
	color: white;
	gap: var(--space-xx-small);
}
.proTips .container .c_inner .list_listItem li {
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 1.6rem 0;
	border-bottom: 1px solid var(--color-base-mid-dark);
	cursor: pointer;
	img {
		width: 6rem;
		height: auto;
	}
}

.list_listItem {
	display: flex;
	flex-direction: column;
	gap: var(--space-xx-small);
	color: white;
	li {
		display: block;
		.listItem_info {
			display: flex;
			flex-direction: column;
			gap: 0.4rem;
			width: 100%;
			.info_header {
				display: flex;
				gap: 0.8rem;
				h3 {
					flex: 1;
					font-weight: var(--font-w-light);
					font-size: var(--font-s-mid);
					line-height: 1.9rem;
					overflow: hidden;
					width: 4rem;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.listItem_meta {
				display: flex;
				justify-content: space-between;
				@media screen and (max-width: 1280px) {
					flex-direction: column;
					gap: 0.6rem;
				}
				.meta_icon {
					display: flex;
					gap: 1rem;
					div {
						display: flex;
						align-items: center;
						gap: var(--space-xx-small);
						font-weight: var(--font-w-light);
						font-size: var(--font-s-small);
						line-height: 1.551rem;
						color: var(--color-base-mid);
					}
				}
			}
		}
		.img_box {
			display: flex;
			justify-content: center;
			align-items: center;
			overflow: hidden;
			min-width: 6rem;
			height: 6rem;
			background-color: white;
			border-radius: 50%;
		}
	}

	.meta_subInfo {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		flex-direction: row;
		position: relative;
		color: var(--color-base-mid);
		font-weight: var(--font-w-light);
		font-size: var(--font-s-small);
		line-height: 1.551rem;
		:nth-child(1),
		:nth-child(2) {
			padding-right: 0.8rem;
		}
		:nth-child(2),
		:nth-child(3) {
			padding-left: 0.8rem;
		}
	}
	.meta_subInfo :nth-child(1)::after,
	.meta_subInfo :nth-child(2)::after {
		content: '';
		display: inline-block;
		height: 50%; /* 원하는 높이로 조절 */
		border-right: 1px solid var(--color-base-mid-dark);
		position: absolute;
		top: 25%; /* border가 텍스트 중앙에 위치하도록 조절 */
		padding-right: 0.8rem;
	}
}
.button_box {
	padding-top: 1rem;
	text-align: end;
	.c_button {
		color: white;
		border-radius: 0.6rem;
		padding: 1.3rem 1.6rem;
		font-weight: var(--font-w-medium);
		line-height: 1.79rem;
		height: 4.4rem;
	}
}
.pagination {
	margin-top: var(--space-x-large);
}
</style>
